import React from "react";
import { Text } from "react-native";
import tw from "twrnc";

const AppText = ({ style, children, ...props }) => {
  return (
    <Text style={[tw`text-[14px] text-[rgb(46,63,82)]`, style]} {...props}>
      {children}
    </Text>
  );
};

export default AppText;
